import { render, staticRenderFns } from "./RegistrationAttachment.vue?vue&type=template&id=9da3d122&scoped=true"
import script from "./RegistrationAttachment.vue?vue&type=script&lang=ts"
export * from "./RegistrationAttachment.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationAttachment.vue?vue&type=style&index=0&id=9da3d122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da3d122",
  null
  
)

export default component.exports